go-footer {
  /**
    @prop --footer-nav-section-padding:
    Padding for the navigation section
    - default: 3rem 0
  */
  --footer-nav-section-padding: 3rem 0;
  /**
    @prop --footer-bottom-section-padding:
    Padding for the bottom section
    - default: 2rem 0
  */
  --footer-bottom-section-padding: 2rem 0;
  /**
    @prop --footer-copyright-section-padding:
    Padding for the copyright section
    - default: 2rem 0
  */
  --footer-copyright-section-padding: 2rem 0;
  /**
    @prop --footer-bg-color:
    Background color for the footer
    - default: var(--go-color-lightest)
  */
  --footer-bg-color: var(--go-color-lightest);
  /**
    @prop --footer-text-color:
    Text color for the footer
    - default: var(--go-color-text)
  */
  --footer-text-color: var(--go-color-text);
  /**
    @prop --footer-separator-color:
    Color for separator between sections
    - default: var(--go-color-neutral-300)
  */
  --footer-separator-color: var(--go-color-neutral-300);

  display: block;
  background: var(--footer-bg-color);
  color: var(--footer-text-color);
  go-nav-link {
    --nav-link-padding: 0.5em;
  }
  a,
  go-nav-list {
    --go-color-link: var(--footer-text-color);
    --nav-list-header-color: var(--footer-text-color);
    .nav-link-text-description {
      --nav-link-description-color: var(--footer-text-color);
    }
  }
  .nav-container {
    padding: var(--footer-nav-section-padding);
  }
  .footer-bottom {
    border-top: 1px solid var(--footer-separator-color);
    padding: var(--footer-bottom-section-padding);
  }
  .copyright {
    border-top: 1px solid var(--footer-separator-color);
    padding: var(--footer-copyright-section-padding);
  }
}
